import * as d3 from 'd3'

export default {

  methods: {

    call_Block(selection, disc, blk) {

      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
          d3.select(this).transition().duration(50).style('opacity', .4)
        })
        .on('mouseout', function() {
          d3.select(this).transition().duration(50).style('opacity', 1)
        })
        .on('click', () => {
          this.link_Action(disc,'' , blk) 
        })
    },

    event_Link(selection, disc, d, blk) {

      // if (col.filter == '') return

      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
          d3.select(this).transition().duration(50).style('opacity', .4)
        })
        .on('mouseout', function() {
          d3.select(this).transition().duration(50).style('opacity', 1)
        })
        .on('click', () => {
          this.link_Action(disc, d, blk) 
        })
    },

    link_Action(disc_, d_=null, data) {

      let dataSource = {}

      Object.keys(this.keys).forEach(d=>{
        dataSource = {...dataSource, [d]: data[this.keys[d]]}
      })

      let filterString_ = disc_.filter || ''

      console.log(dataSource, filterString_)

      let req = disc_.json || 'request'
      // if (d_) {
      //   req += `_${d_.code}_${d_.type}`
      // }
      if (data.AREA == 'TOPSIDE' || data.MOD == 'LQ') {
        req = 'ZONE'
      } else {
        disc_.json || 'request'
      }

      // seting request_ from A/G jsonProps
      let request_ = this.getRequestColumnProps(req, dataSource, this.ColumnProps)
      if(!request_) return

      if(request_.iFilters.filterString) {
        request_.iFilters.filterString += filterString_ ? ` AND ${filterString_} ` : ''
      } else {
        request_.iFilters.filterString = filterString_||''
      }

      // Combine filterStrings
      request_ = {...request_,
        filters : {
          ...this.FilterValues,
          ...request_.filters,
        },
        iFilters: { 
          filterString : request_.iFilters.filterString||'',
          inputFilter : request_.iFilters.inputFilter,},
      }
      this.$emit('request-action', request_)
    },

  } 
}